import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import httpService from '../../services/httpService';

export default function SendMasPage(): JSX.Element {
  const selectedCommunity = useSelector((state: RootState) => state.application.selectedCommunity);
  const selectedDashboard = useSelector((state: RootState) => state.application.selectedDashboard);
  const [message, setMessage] = useState<string | null>(null);
  const [isSending, setIsSending] = useState<boolean>(false);

  const handleFire = async () => {
    if (!selectedCommunity) {
      setMessage('Community ID (selected community) is required');
      setTimeout(() => setMessage(null), 3000);
      return;
    }

    setIsSending(true);
    try {
      await httpService.post('/marketing/automations/mas/testing', {
        communityId: selectedCommunity,
        dashboardId: selectedDashboard,
      });

      setMessage(`Fired MAS`);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('MAS test failed', err);
      setMessage(`Error firing MAS: ${err instanceof Error ? err.message : 'unknown error'}`);
    } finally {
      setIsSending(false);
      setTimeout(() => setMessage(null), 5000);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="max-w-lg w-full bg-white shadow-md rounded p-6">
        <h2 className="text-lg font-semibold mb-4">Send MAS</h2>

        <div className="mb-4">
          <div className="text-sm text-gray-700">
            Sending from community: <strong>{selectedCommunity ?? '-'}</strong>
            {selectedDashboard !== undefined && (
              <> (dashboard: <strong>{selectedDashboard}</strong>)</>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleFire}
            disabled={isSending || !selectedCommunity}
            aria-busy={isSending}
            className={`bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded ${isSending || !selectedCommunity ? 'opacity-60 cursor-not-allowed' : ''}`}
          >
            {isSending ? 'Sending…' : 'Fire'}
          </button>

          {message && <div className="text-sm text-green-600">{message}</div>}
        </div>
      </div>
    </div>
  );
}